import { AdminOrganizations } from '@platform/client';
import { OrganizationDetailProject } from '@platform/client/schemas';
import { ColumnDef, createColumnHelper } from '@tanstack/react-table';
import { useContext, useMemo } from 'react';
import { AdminTable, AdminTableContext } from '../../AdminTable';
import { formatDateStr } from '../../../dashboard/my-projects/utils';
import { ProjectLink } from '../projects/ProjectsAdmin';
import { NoRecordsFoundTabContent, ProfileTabContainer } from '../../components/ProfileComponents';

const columnHelper = createColumnHelper<OrganizationDetailProject>();

export const ProjectTabContent = ({ organizationId }: { organizationId: number }) => {
  const { adminQueryOptionsV2 } = useContext(AdminTableContext);
  const {
    data: projectsData,
    isLoading,
    isError,
    isSuccess,
  } = AdminOrganizations.useGetOrganizationProjects({
    organization__id: organizationId,
    ...adminQueryOptionsV2,
  });
  const columns = useMemo(
    () =>
      [
        columnHelper.accessor('id', {
          header: 'id',
          cell: (info) => info.getValue(),
          size: 5,
        }),
        columnHelper.accessor('name', {
          header: 'Name',
          cell: ({ row }) => (
            <ProjectLink projectId={row.original.id} projectName={row.original.name} />
          ),
          size: 400,
        }),
        columnHelper.accessor('representativeName', {
          header: 'Representative',
          cell: ({ row }) => row.original.representativeName, // make profile link for reps once page complete
        }),
        columnHelper.accessor('publishingStage', {
          header: 'Publishing Stage',
          cell: ({ row }) => row.original.publishingStage,
        }),
        columnHelper.accessor('createdAt', {
          header: 'Created At',
          cell: ({ row }) => formatDateStr(row.original.createdAt),
        }),
      ] as ColumnDef<OrganizationDetailProject>[],
    [],
  );
  return (
    <ProfileTabContainer>
      {isSuccess && projectsData?.projects.length === 0 ?
        <NoRecordsFoundTabContent recordType='organization' />
      : <AdminTable
          isSimple
          columns={columns}
          data={projectsData?.projects || []}
          filteredCount={projectsData?.filteredCount || 0}
          isError={isError}
          isLoading={isLoading}
          isSuccess={isSuccess}
        />
      }
    </ProfileTabContainer>
  );
};
